import ClockifySetting from './ClockifySettings';

export default ClockifySetting;
